export default {"src":"/_next/static/image/src/components/BillingInformationForm/secure-lock.4b7a35e0a23e3274af22380a726d8d33.svg","height":17,"width":13};